export const environment = {
    
    api_url: "https://jcsakurainternational.com/api",
    app_url: "http://localhost:3000",
    img_url: "https://jcsakurainternational.com/"
    
  };